import { TerminalClosure } from "@towersystems/roam-common/lib/generated-types";
import Terminal from "../../../../utilities/data/model/Terminal";
import { useCloseShiftProcess } from "../../utils/shift/hooks";
import { CloseShiftProcessContext } from "../../utils/shift/context";

export interface CloseShiftControllerProps {
  children?: React.ReactNode | React.ReactNode[] | null;
  terminal: Terminal;
  terminalClosure: TerminalClosure;
}

export const CloseShiftController = ({
  children,
  terminal,
  terminalClosure,
}: CloseShiftControllerProps) => {
  const closeShiftProcess = useCloseShiftProcess({
    paymentMethodIds:
      terminalClosure.countedPaymentsSummary
        ?.filter((p) => p.payTypeId === "1")
        .map((p) => ({
          paymentMethodId: p.paymentMethodId,
          amount: p.total,
          expected: p.expected,
        })) || [],
  });

  return (
    <CloseShiftProcessContext.Provider value={closeShiftProcess}>
      {children}
    </CloseShiftProcessContext.Provider>
  );
};
